import { useState, useEffect, useCallback, useRef } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  setCheckboxSelect,
  resetPriceRange,
} from "../../../redux/filtersSlice"; // Adjust the path if necessary
// Custom Option Component to add checkboxes
const CustomOption = (props) => {
  const { data, isSelected, innerRef, innerProps } = props;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
    >
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => {}}
        className="form-checkbox"
      />
      <label className="text-sm">{data.label}</label>
    </div>
  );
};

// Multi-select with checkboxes
const CheckboxSelect = ({ label, options, filterId }) => {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.view.drawer);
  const selectedOptions = useSelector(
    (state) => state.filters.checkboxSelect[filterId] || [],
  );
  const [localSelectedOptions, setLocalSelectedOptions] =
    useState(selectedOptions);
  const timeoutRef = useRef(null);

  // Custom debounced function - use useCallback to memoize the function
  const debouncedUpdate = useCallback(
    (updatedOptions) => {
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Set new timeout
      timeoutRef.current = setTimeout(() => {
        dispatch(
          setCheckboxSelect({ filterId, selectedValues: updatedOptions }),
        );
        dispatch(resetPriceRange());
      }, 1000);
    },
    [dispatch, filterId],
  );

  const handleChange = (selected) => {
    setLocalSelectedOptions(selected);
    // Clear any existing timeout and call the debounced function
    debouncedUpdate(selected);
  };

  // Sync local state with Redux state only if it differs
  useEffect(() => {
    if (
      JSON.stringify(localSelectedOptions) !== JSON.stringify(selectedOptions)
    ) {
      setLocalSelectedOptions(selectedOptions);
    }
  }, [selectedOptions, localSelectedOptions]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className={`max-w-sm  ${drawerOpen ? "w-full" : "md:hidden"}`}>
      <h3 className="font-bold text-sm text-primeColor mb-2 capitalize">
        {label}
      </h3>
      <Select
        options={options}
        value={localSelectedOptions}
        onChange={handleChange}
        isMulti
        components={{ Option: CustomOption }}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        className="react-select-container"
        classNamePrefix="react-select"
        styles={{
          control: (provided) => ({
            ...provided,
            fontSize: "12px", // Adjust font size
            minHeight: "35px",
            padding: "0 2px", // Add padding to center text vertically
            alignItems: "center", // Ensure content is centered
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: "12px", // Adjust font size for dropdown menu
          }),
          multiValue: (provided) => ({
            ...provided,
            fontSize: "12px", // Font size for selected options
          }),
          multiValueLabel: (provided) => ({
            ...provided,
            fontSize: "12px", // Font size for selected option labels
          }),
          multiValueRemove: (provided) => ({
            ...provided,
            fontSize: "12px", // Font size for remove button in selected options
          }),
        }}
      />
    </div>
  );
};

export default CheckboxSelect;
